import { NgModule, Pipe, PipeTransform } from '@angular/core';  
import { DatePipe, getLocaleWeekEndRange } from '@angular/common';  
import { date } from 'ngx-custom-validators/src/app/date/validator';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { isEmpty } from 'lodash';
  
@Pipe({  
  name: 'datePipe'  
})  
export class datePipe implements PipeTransform {  
  transform(value: Date): String {  
    if(isEmpty(value)) {
      return null;
    }
    return `${moment.tz(value, environment.displayTimeZone).format(environment.dateFormat)} (EST)`//new DatePipe('en-Us').transform(value,environment.dateFormat,environment.displayTimeZone);
  }     
  
}  

@Pipe({
  name: 'momentDate'
})
export class MomentDatePipe implements PipeTransform {
  transform(value: Date, format: string = 'MM-DD-YYYY'): String {
    if(isEmpty(value)) {
      return null;
    }
    return moment(value).format(format);
  }
}

@Pipe({  
    name: 'dateTimePipe'  
  })  
  export class dateTimePipe implements PipeTransform {  
  transform(value: Date, timezone = null): String {
      if(isEmpty(value)) {
        return null;
      }
    if (!timezone)
      return `${moment.tz(value, environment.displayTimeZone).format(environment.dateTimeFormat)} (EST)`//new DatePipe('en-Us').transform(value,environment.dateTimeFormat,environment.displayTimeZone);
    else {
      const gmt = " (GMT" + moment.tz(timezone).format('Z') + ") "
      return `${moment.tz(value, timezone).format(environment.dateTimeFormat)} ${gmt}`//new DatePipe('en-Us').transform(value,environment.dateTimeFormat,environment.displayTimeZone);

    }
    }     
    
  }  
@Pipe({
  name: 'UTCToEST'
})
export class UTCToEST implements PipeTransform {
  transform(
    utcDate: string | Date,
    timeZone: string = 'America/New_York',
    format: 'full' | 'date' | 'time' = 'full'
  ): string {
    if (!utcDate) return '';

    const date = new Date(utcDate);

    // Convert to target time zone
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });

    const parts = formatter.formatToParts(date);
    const lookup: any = {};
    parts.forEach(p => (lookup[p.type] = p.value));

    const formattedDate = `${lookup.month}-${lookup.day}-${lookup.year}`;
    const formattedTime = `${lookup.hour}:${lookup.minute}:${lookup.second}`;

    if (format === 'date') return formattedDate;
    if (format === 'time') return formattedTime;
    return `${formattedDate} ${formattedTime}`;
  }
}
